module.exports = __webpack_public_path__ + "img/Fillball-2.4dcb5d43.gif";